import React from 'react';
import ReactDOM from 'react-dom';
import SwitchLayouts from './layouts/SwitchLayouts'
import * as serviceWorker from './serviceWorker';
import './assets/style/index.css';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "@babel/polyfill";

ReactDOM.render(
  <SwitchLayouts />,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
